import React from 'react'
import HeaderImage from '../assets/images/Header.jpg'

const NewProduct = () => {
  return (
    <div className="min-h-screen bg-transparent pt-20">
      <div className="max-w-[1440px] mx-auto px-4 py-12">
        {/* Başlık */}
        <div 
          className="text-white p-8 rounded-lg mb-10 relative overflow-hidden"
          style={{
            backgroundImage: `url(${HeaderImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-40"></div>
          <h1 className="text-3xl md:text-4xl font-bold text-center relative z-10">Yeni Ürün Satışı</h1>
        </div>

        {/* 4 Kutu Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {/* 1. Kutu - Servo Sürücü Satışı */}
          <div className="bg-white rounded-lg shadow-lg p-6 relative z-10 hover:shadow-xl transition-shadow duration-300">
            <div className="flex flex-col items-center text-center">
              <img
                src={require('../assets/images/yeni-urun/AKD_Large_4.png.webp')}
                alt="Servo Sürücü"
                className="w-full h-[28rem] object-contain rounded-lg mb-4"
              />
              <h2 className="text-xl font-semibold text-[#2E3192] mb-3">Servo Sürücü Satışı</h2>
              <p className="text-gray-700 leading-relaxed">
                Hemen Stoktan Teslim Servo Sürücü Modelleri!<br />
                Uygun fiyatlar, uzman teknik destek ve hızlı kargo avantajıyla sipariş vermek için bizimle iletişime geçin.
              </p>
            </div>
          </div>

          {/* 2. Kutu - Servo Motor Satışı */}
          <div className="bg-white rounded-lg shadow-lg p-6 relative z-10 hover:shadow-xl transition-shadow duration-300">
            <div className="flex flex-col items-center text-center">
              <img
                src={require('../assets/images/yeni-urun/AKM_Series.jpg')}
                alt="Servo Motor"
                className="w-full h-[28rem] object-contain rounded-lg mb-4"
              />
              <h2 className="text-xl font-semibold text-[#2E3192] mb-3">Servo Motor Satışı</h2>
              <p className="text-gray-700 leading-relaxed">
                Yüksek hassasiyetli, dayanıklı ve enerji verimliliği yüksek servo motorlar!<br />
                Her türlü uygulamaya özel farklı güç, tork ve ebatlarda servo motor çözümlerinden yararlanmak için iletişime geçin.
              </p>
            </div>
          </div>

          {/* 3. Kutu - HMI / Endüstriyel PC Satışı */}
          <div className="bg-white rounded-lg shadow-lg p-6 relative z-10 hover:shadow-xl transition-shadow duration-300">
            <div className="flex flex-col items-center text-center">
              <img
                src={require('../assets/images/yeni-urun/Exor_JMobile-.jpg')}
                alt="HMI / Endüstriyel PC"
                className="w-full h-[28rem] object-contain rounded-lg mb-4"
              />
              <h2 className="text-xl font-semibold text-[#2E3192] mb-3">HMI / Endüstriyel PC Satışı</h2>
              <p className="text-gray-700 leading-relaxed">
                Güçlü, dayanıklı ve endüstriyel ortamlara uygun çözümler.<br />
                HMI (Human Machine Interface) ve Endüstriyel PC modellerimiz zorlu üretim ortamlarında kararlı performans sunar.<br />
                Geniş ürün yelpazemiz hakkında bilgi almak için iletişime geçin.
              </p>
            </div>
          </div>

          {/* 4. Kutu - Yedek Parça ve Aksesuar Satışı */}
          <div className="bg-white rounded-lg shadow-lg p-6 relative z-10 hover:shadow-xl transition-shadow duration-300">
            <div className="flex flex-col items-center text-center">
              <img
                src={require('../assets/images/yeni-urun/accessories.jpg')}
                alt="Yedek Parça ve Aksesuar"
                className="w-full h-[28rem] object-contain rounded-lg mb-4"
              />
              <h2 className="text-xl font-semibold text-[#2E3192] mb-3">Yedek Parça ve Aksesuar Satışı</h2>
              <p className="text-gray-700 leading-relaxed">
                Servo Sürücü, Motor, PLC ve HMI ürünlerine dair her türlü yedek parça ve aksesuar satışı konusunda destek vermekteyiz.<br />
                Kablolar, konnektörler, fren dirençleri vb. ürünler ve bunların uyumluluğu konusunda uzman desteği almak için bizimle iletişime geçin.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewProduct